<script setup lang="ts">
import { ref } from 'vue';
import useGlobalStore from '@/store/globalStore';
import { get } from 'lodash-es';
const dialogVisible = ref(false);
const privateInfoKeyLabelMapping = {
  'administrator.displayName': '姓名',
  'administrator.domainAccount': '域账号',
  'info.workNo': '工号',
  'administrator.email': 'Email',
  'info.accountId': 'Account Id',
  'info.nickName': '昵称',
  'administrator.id': '管理员ID',
  'administrator.organizations': 'People组织',
  'administrator.roles': '角色',
  'info.accessToken': 'Access Token',
};
const globalStore = useGlobalStore();
const keys = Object.keys(privateInfoKeyLabelMapping);
const geValue = (key) => {
  const privateInfo = globalStore.coreData;
  const value = get(privateInfo, key);
  if (key.includes('displayName')) {
    return `<p>${value}<span>${get(
      privateInfo,
      'administrator.statusName'
    )}</span></p>`;
  }
  if (key.includes('organizations')) {
    return (value || [])
      .map(
        (item) =>
          `<p>${item.positionName} <span>(${item.bizOrgPathName})</span></p>`
      )
      .join('');
  }
  if (key.includes('roles')) {
    return (value || []).map((item) => `<p>${item.name}</p>`).join('');
  }
  return value;
};

console.log('globalStore.coreData', globalStore.coreData);

defineExpose({
  openDialog: () => {
    dialogVisible.value = true;
  },
  closeDialog: () => {
    dialogVisible.value = false;
  },
});
</script>

<template>
  <n-dialog
    v-model="dialogVisible"
    title="个人信息"
    size="large"
    :primary-button="false"
    :secondary-button="false"
  >
    <div class="private-info-table">
      <table>
        <tbody>
          <tr v-for="key in keys" :key="key">
            <td>{{ privateInfoKeyLabelMapping[key] }}</td>
            <td v-html="geValue(key)"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </n-dialog>
</template>

<style scoped lang="scss">
.private-info-table {
  table,
  tr,
  td {
    border: 1px solid #f4f5f7;
  }
  td {
    padding: 5px 10px;
  }
  :deep(p) {
    margin: 0 !important;
    span {
      color: #999;
      margin-left: 5px;
      font-size: 12px;
    }
  }

  table {
    width: 100%;
  }
}
</style>
